import React from 'react';
import { Link } from "react-router-dom";

const BlogDetailsContentWrapperTwo = ({ post, sidebar }) => {
    return (
        <article className="blog-post-details">
            {/* <figure className="blog-post-thumb">
                <img src={require('../../assets/img/' + post.thumb)} alt={post.title} />
            </figure> */}

            <div className="blog-post-txt-wrap">
                <div className="row">

                    <div className={`m-auto order-0 ${!sidebar ? 'col-md-9 col-lg-8' : 'col-12'}`}>
                        <div className="blog-post-txt">
                            <h2 className="h3">{post.title}</h2>

                            <div dangerouslySetInnerHTML={{ __html: post.content }} />
                        </div>

                        <div className="share-article text-center">

                            <div className="mt-sm-25">
                            <Link
                                to="/contact"
                                className="btn-outline"
                                style={{
                                    width: '50%',
                                    backgroundColor: 'white', // Background color white
                                    border: '2px solid #BB2649', // Border color dark red
                                    color: '#BB2649', // Text color black
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = '#BB2649'; // Hover background color dark red
                                    e.target.style.color = 'white'; // Hover text color white
                                    e.target.style.border = '2px solid #BB2649'; // Hover border remains dark red
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'white'; // Reset background color
                                    e.target.style.color = '#BB2649'; // Reset text color
                                    e.target.style.border = '2px solid #BB2649'; // Reset border color
                                }}
                            >
                                Apply
                            </Link>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article >
    );
};

export default BlogDetailsContentWrapperTwo;